// extracted by mini-css-extract-plugin
export default {"contenido":"estilo_contenido__b0DOE","experiencia":"estilo_experiencia__SIkv2","fecha":"estilo_fecha__PoDj2","enlace":"estilo_enlace__fRvzy"};